class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// The "Expected delivery" dates (#delivery-estimate) are blank in the Liquid markup and only filled by
// assets/delivery-estimate.js. Every path that swaps the drawer's innerHTML therefore has to re-run it,
// otherwise the dates vanish with the old markup.
function refreshDrawerDeliveryEstimate() {
  if (typeof window.updateDeliveryEstimate === 'function') window.updateDeliveryEstimate();
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  // A cart change made elsewhere (product form, Home Bar app, cart page): re-render the drawer from its own
  // section. The inherited version fetched the CART PAGE section and poured its markup into the drawer.
  //
  // This fetch resolves AFTER product-form.js has already rendered the drawer and filled the delivery
  // dates, so without the refresh below the second render wiped the dates for good.
  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('.drawer__inner');
        const target = document.querySelector('#CartDrawer .drawer__inner');
        if (source && target) target.innerHTML = source.innerHTML;
        const wrapper = document.querySelector('cart-drawer');
        if (wrapper && source) wrapper.classList.toggle('is-empty', source.querySelectorAll('.cart-item').length === 0);
        refreshDrawerDeliveryEstimate();
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


class CartQuickAdd extends HTMLElement {
  constructor() {
    super();

    const cartItems = document.querySelector('cart-drawer-items');
    const sectionsToRender = cartItems.getSectionsToRender();

    this.addEventListener('click', (event) => {
      // add a certain item to cart (e.g. gift wrapping) with one-click from within the cart
      event.preventDefault();

      let formData = {
      'items': [{
              'id': this.dataset.variantId,
              'quantity': 1
          }],
      'sections': sectionsToRender.map((section) => section.section).join(","),
      };

      console.log(formData);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => {
        return response.text();
      })
      .then(response => {
        const parsedState = JSON.parse(response);

        sectionsToRender.map((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        })
        refreshDrawerDeliveryEstimate();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  }
}

customElements.define('cart-quick-add', CartQuickAdd);
